export default "/images/e280e8528ca9c8fd1fdbc9d8195443cd.avif";